import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ForbiddenPage = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4" data-testid="forbidden-page">
      <div className="bg-red-50 p-6 rounded-full mb-6">
        <ShieldX className="h-16 w-16 text-red-500" />
      </div>
      
      <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2">
        Zugriff verweigert
      </h1>
      
      <p className="text-slate-600 mb-6 max-w-md">
        Sie haben keine Berechtigung, diese Seite aufzurufen. 
        Diese Funktion ist nur für Administratoren verfügbar.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-3">
        <Button asChild variant="outline">
          <Link to="/" data-testid="forbidden-home-btn">
            <Home className="h-4 w-4 mr-2" />
            Zum Dashboard
          </Link>
        </Button>
        
        <Button asChild onClick={() => window.history.back()}>
          <Link to="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} data-testid="forbidden-back-btn">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Zurück
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ForbiddenPage;
